module.exports = __webpack_public_path__ + "static/media/patient8.5d229d7b.png";